import { useTranslation } from 'next-i18next'
import { Ref, FC } from 'react'

import Input from '~/bootcamp/Activities/components/Input'
import InputNumbersOnly from '~/bootcamp/Activities/components/InputNumbersOnly'

interface IProps {
  onChange: (value: string, name: string) => void
  name: string
  value: string
  isError?: boolean
  inputRef?: Ref<HTMLInputElement | null>
  onEnter?: () => void
}

const LatticeCarriedNumber: FC<IProps> = (props) => {
  const { t } = useTranslation('generics')
  const { onChange, name, value, isError, onEnter } = props

  return (
    <Input
      aria-label={t('ariaLabelButtons.insertCarriedNumber')}
      isError={isError}
      isSmall
      maxDigits={1}
      name={name}
      onChange={onChange}
      onEnter={onEnter}
      type="text"
      value={value || ''}
    />
  )
}

const LatticeSumInput: FC<IProps> = (props) => {
  const { t } = useTranslation('generics')
  const { onChange, name, value, isError, inputRef, onEnter } = props

  return (
    <>
      {/* Hello LatticeSumInput! */}
      <InputNumbersOnly
        aria-label={t('ariaLabelButtons.insertLatticeSum')}
        autoFocus={!!inputRef}
        inputRef={inputRef}
        isError={isError}
        maxDigits={1}
        name={name}
        onChange={onChange}
        onEnter={onEnter}
        value={value || ''}
      />
    </>
  )
}

const LatticeSumInputWithDecimal: FC<
  IProps & {
    commaPostion?: 'bottom' | 'right' | undefined
    onCommaClick: (index: string) => void
    decimalIndex: string
    commaDashed: string
    decimalError: boolean
    commaFilled: string
  }
> = (props) => {
  const { t } = useTranslation('generics')
  const {
    onChange,
    name,
    value,
    commaPostion,
    onCommaClick,
    decimalIndex,
    isError,
    commaDashed,
    commaFilled,
    decimalError,
    inputRef,
    onEnter,
  } = props
  const [, sumCommaIndex] = name.split(':')

  const positionStyle = commaPostion === 'right' ? '-right-1 bottom-1 translate-x-1/2' : '-bottom-1 translate-y-1/2'
  const decimalErrorStyle = decimalError ? 'border-2 border-red rounded-4xl' : ''

  return (
    <div
      className={`relative flex justify-center items-center ${
        commaPostion === 'right' ? 'w-16 lg:w-24.5 h-15.5' : 'lg:w-10 h-16 lg:h-24.5'
      }`}
    >
      <InputNumbersOnly
        aria-label={t('ariaLabelButtons.insertLatticeSum')}
        autoFocus={!!inputRef}
        inputRef={inputRef}
        isError={isError}
        maxDigits={1}
        name={name}
        onChange={onChange}
        onEnter={onEnter}
        value={value || ''}
      />
      {commaPostion && (
        <img
          alt="Decimal icon"
          className={`absolute ${positionStyle} w-3 h-3 cursor-pointer ${decimalErrorStyle}`}
          onClick={() => onCommaClick(sumCommaIndex)}
          src={sumCommaIndex !== decimalIndex ? commaDashed : commaFilled}
          style={{ paddingLeft: '1px', paddingTop: '1px' }}
        />
      )}
    </div>
  )
}
export { LatticeCarriedNumber, LatticeSumInput, LatticeSumInputWithDecimal }
